import { useClientContext } from "@hooks/index";
import { useQuery } from "@tanstack/react-query";
import { getAllProcess } from "./index";

export const useGetAllProcess = () => {
  const customFetch = useClientContext();

  return useQuery({
    retry: false,
    queryKey: ["process"],
    queryFn: getAllProcess(customFetch),
  });
};
